import PrivacyPolicyPage from "pages/legal/PrivacyPolicyPage";
import React from "react";

const PrivacyPolicyRoute = () => <PrivacyPolicyPage />;

export default PrivacyPolicyRoute;
